import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import {
  obtenerCatalogosPorNemGrupo,
  setListaCatalogosGrupo,
} from "../../sliceRedux/Reserva.slice";
import { useSelector } from "react-redux";
import { nemonicoGruposCatalogos } from "../../constantes/appConstantes";

const ModalTelefonos = (props) => {
  const { modal, callbackSave, callbackModal, showLoader, hideLoader, dispatch } = props;
  const listaTiposTelefono = useSelector((state) => state.reserva.listaCatalogosGrupo);
  const [tipoTelefonos, setTipoTelefonos] = useState([]);

  useEffect(() => {
    showLoader();
    dispatch(obtenerCatalogosPorNemGrupo("TIPO_TELEFONO"));
  }, []);

  useEffect(() => {
    if (listaTiposTelefono.code === 200) {
      setTipoTelefonos(listaTiposTelefono?.object ?? []);
    }
    return () => {
      hideLoader();
      dispatch(setListaCatalogosGrupo({ ...listaTiposTelefono, code: 0 }));
    };
  }, [listaTiposTelefono.code]);

  const onClickClose = () => {
    formik.resetForm();
    callbackModal();
  };
  const validationSchema = Yup.object().shape({
    nomTipoContacto: Yup.string().required("Campo requerido."),
    contacto: Yup.string()
      .required("Campo requerido.")
      .when("nemTipoContacto", {
        is: nemonicoGruposCatalogos.TIPO_CELULAR,
        then: (schema) =>
          schema.matches(
            /^09\d{8}$/,
            "El número de celular debe empezar con 09 y tener 10 dígitos."
          ),
        otherwise: (schema) => schema,
      }),
    codTipo: Yup.number().required("Campo requerido.").nullable(),
  });

  const formik = useFormik({
    initialValues: {
      nomTipoContacto: "",
      nemTipoContacto: "",
      codContactoConst: null,
      contacto: "",
      codTipo: null,
    },
    validationSchema: validationSchema,
    onSubmit: (data) => {
      callbackSave(data);
    },
  });

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const isFormFieldValid = (name) => {
    const isValid = !!(formik.touched[name] && formik.errors[name]);
    return isValid;
  };

  const renderFooterAC = (stateMethod) => {
    return (
      <div className="flex justify-content-center">
        <Button label="Cancelar" icon="pi pi-times-circle" onClick={onClickClose} severity="info" />
        <Button label="Guardar" icon="pi pi-save" type="button" onClick={formik.handleSubmit} />
      </div>
    );
  };

  return (
    <Dialog
      visible={modal}
      header="Agregar Celular / Teléfono"
      modal
      onHide={onClickClose}
      footer={renderFooterAC(null)}
    >
      <form>
        <div className="flex flex-column ">
          <label htmlFor="codTipo" required>
            Tipo:
          </label>
          <Dropdown
            id="codTipo"
            name="codTipo"
            optionLabel="nomCatalogo"
            optionValue="codCatalogo"
            placeholder="Seleccione un tipo"
            options={tipoTelefonos}
            value={formik.values.codTipo}
            className={classNames({
              "p-invalid": isFormFieldValid("codTipo"),
            })}
            onChange={(e) => {
              let tipo = tipoTelefonos.find((item) => item.codCatalogo === e.value);
              formik.setFieldValue("nomTipoContacto", tipo?.nomCatalogo ?? "");
              formik.setFieldValue("nemTipoContacto", tipo?.nomNemonico ?? "");
              formik.handleChange(e);
            }}
            style={{ width: "100%" }}
          />

          {getFormErrorMessage("codTipo")}
        </div>
        <div className="flex flex-column">
          <label htmlFor="contacto" required>
            Número:
          </label>
          <InputText
            id="contacto"
            name="contacto"
            keyfilter="int"
            maxLength={10}
            autoComplete="off"
            value={formik.values.contacto}
            className={classNames({
              "p-invalid": isFormFieldValid("contacto"),
            })}
            onChange={formik.handleChange}
            style={{ width: "100%" }}
          />
          {getFormErrorMessage("contacto")}
        </div>
      </form>
    </Dialog>
  );
};

export default ModalTelefonos;
